import React, {Component} from 'react';
import axios from '../../axios-signup';
import {Redirect} from 'react-router-dom';
import Error from '../../components/UI/Error';
import wrapper from '../../hoc/wrapper';
import Header from "../../components/Header/Header";
import { Loader } from 'react-overlay-loader';

class InstallRegion extends Component {
    state = {
        emailAddress: this.props.location.state.emailAddress,
        submitted: false,
        links: {},
        errorMsg: '',
        unauthorized: false,
        region: '',
        loading: false,
        fromAws: this.props.location.state.fromAws || false
    };

    handleSubmit = (event) => {
        event.preventDefault();
        this.setState({loading: true});
        axios.post('/install-region', {
            emailAddress: this.state.emailAddress,
            region: this.state.region === '' ? 'us-west-2' : this.state.region
        }).then(res => {
            this.setState({submitted: true, links: res.data.links, loading: false});
        }).catch(err => {
            if (err.response.status === 401) {
                this.setState({unauthorized: true, loading: false});
            } else {
                this.setState({errorMsg: err.response.data.error, loading: false})
            }
        })
    };

    handleChangeRegion = (event) => {
        this.setState({region: event.target.value});
    };

    componentDidMount() {
        window.$(function () {
            window.jcf.replaceAll();
        });
    }
    render() {
        let redirect = null;

        if (this.state.submitted) {
            redirect = <Redirect to={{
                pathname: '/signup/cloud-formation',
                state: {emailAddress: this.state.emailAddress, links: this.state.links, fromAws: this.state.fromAws}
            }}/>
        } else if (this.state.unauthorized) {
            redirect = <Redirect to="/signup/"/>
        }
        return (
            <div>
                <Header currentWizard="7" fromAws={this.state.fromAws}/>
                <main role="main">
                    <Loader fullPage={true} loading={this.state.loading}/>
                    <section className="section yellow">
                        {redirect}
                        <div className="container">
                            <div className="row">
                                <div className="col-md-10 col-center text-center">
                                    <h1 className="black"><strong>Select Region</strong></h1>
                                    <h5 className="gray mb-4"><strong>Please select the aws region you will install the Instance Orchestrator.</strong></h5>
                                    <Error errorMsg={this.state.errorMsg}
                                           divClass="col-lg-6 col-md-7 col-sm-7 col-center"/>
                                    <div className="row">
                                        <div className="col-lg-6 col-md-7 col-sm-7 col-center">
                                            <div className="form-group">
                                                <select value={this.state.region === ''? 'us-west-2' : this.state.region}
                                                        onChange={e => this.handleChangeRegion(e)}>
                                                    <option value='us-east-2'>US East (Ohio)</option>
                                                    <option value='us-east-1'>US East (N. Virginia)</option>
                                                    <option value='us-west-1'>US West (N. California)</option>
                                                    <option value='us-west-2'>US West (Oregon)</option>
                                                    <option value='af-south-1'>Africa (Cape Town)</option>
                                                    <option value='ap-east-1'>Asia Pacific (Hong Kong)</option>
                                                    <option value='ap-southeast-3'>Asia Pacific (Jakarta)</option>
                                                    <option value='ap-south-1'>Asia Pacific (Mumbai)</option>
                                                    <option value='ap-northeast-3'>Asia Pacific (Osaka)</option>
                                                    <option value='ap-northeast-2'>Asia Pacific (Seoul)</option>
                                                    <option value='ap-southeast-1'>Asia Pacific (Singapore)</option>
                                                    <option value='ap-southeast-2'>Asia Pacific (Sydney)</option>
                                                    <option value='ap-northeast-1'>Asia Pacific (Tokyo)</option>
                                                    <option value='ca-central-1'>Canada (Central)</option>
                                                    <option value='cn-north-1'>China (Beijing)</option>
                                                    <option value='cn-northwest-1'>China (Ningxia)</option>
                                                    <option value='eu-central-1'>EU (Frankfurt)</option>
                                                    <option value='eu-west-1'>EU (Ireland)</option>
                                                    <option value='eu-west-2'>EU (London)</option>
                                                    <option value='eu-south-1'>EU (Milan)</option>
                                                    <option value='eu-west-3'>EU (Paris)</option>
                                                    <option value='eu-north-1'>EU (Stockholm)</option>
                                                    <option value='me-south-1'>Middle East (Bahrain)</option>
                                                    <option value='sa-east-1'>South America (São Paulo)</option>
                                                </select>
                                            </div>
                                            <div className="form-group">
                                                <input type="submit" value="Submit" className="btn btn-primary"
                                                       onClick={this.handleSubmit}/>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </main>
            </div>
        )
    }
}

export default wrapper(InstallRegion);
